import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TableCellDirective, TableColumnDirective, TableComponent, TableHeaderDirective } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import type { SrmTicketModel } from '@libs/services/models';
import { LuxonDatePipe } from '@libs/shared/ui';
import { SrmHelperService } from '../../srm-helper.service';
import { SrmTicketLinkDirective } from '../../srm-ticket-link';
import { SrmTicketStatusComponent } from '../../srm-ticket-status';

@Component({
  selector: 'ui-srm-ticket-list-desktop',
  templateUrl: './srm-ticket-list-desktop.component.html',
  styleUrls: ['./srm-ticket-list-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TableComponent,
    TableColumnDirective,
    TableHeaderDirective,
    TableCellDirective,
    IconComponent,
    MatIconButton,
    MatTooltip,
    SrmTicketLinkDirective,
    SrmTicketStatusComponent,
    LuxonDatePipe,
  ],
})
export class SrmTicketListDesktopComponent {
  public readonly helperService: SrmHelperService = inject(SrmHelperService);
  public tickets: InputSignal<SrmTicketModel[]> = input.required();
}
